export const ENGINEERING_RISK_CONSTRUCTION = 1
export const ENGINEERING_RISK_POTTENCIAL = 2
